import { ModalsProvider } from '@carboncopyco/components';
import { Notification } from '@carboncopyco/ui';
import { AnalyticsProvider } from '@carboncopyco/utils';
import { Provider } from 'react-redux';
import { settings } from '../../../settings';
import GlobalEventListener from '../events/GlobalEventListener';
import { store } from '../services/store';
import { ContextProvider } from '../store/context';
import { AppLoader } from './AppLoader';
import { MainApp } from './MainApp';

import './App.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { AnalyticsSessionProvider } from '../store/context/AnalyticsSessionContext';

export function App() {
  return (
    <Provider store={store}>
      <ModalsProvider>
        <ContextProvider>
          <AnalyticsProvider segmentKey={settings.SEGMENT_KEY}>
            <Notification />
            <AnalyticsSessionProvider>
              <GlobalEventListener>
                <AppLoader>
                  <MainApp />
                </AppLoader>
              </GlobalEventListener>
            </AnalyticsSessionProvider>
          </AnalyticsProvider>
        </ContextProvider>
      </ModalsProvider>
    </Provider>
  );
}
